import { registerLeadFilterSection } from "@/features/leads/components/leadFilter/registry";
import { LEAD_FILTER_INDUSTRY_IDS } from "@/features/leads/components/leadFilter/config/leadFilterIndustryConfig";
import VideoProductionPreferences from "@/features/leads/components/leadFilter/components/Preferences/VideoProductionPreferences";
import { PREFERENCE_KEYWORDS_BY_INDUSTRY } from "@/features/leads/components/leadFilter/config/leadFilterIndustryConfig";

registerLeadFilterSection({
  id: "preference",
  industryIds: [LEAD_FILTER_INDUSTRY_IDS.VIDEO_PRODUCTION],
  title: "Service Preferences",
  searchKeywords:
    PREFERENCE_KEYWORDS_BY_INDUSTRY[LEAD_FILTER_INDUSTRY_IDS.VIDEO_PRODUCTION],
  render: () => <VideoProductionPreferences />,
});
